require('./brokerStocksContractStepSuccess.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { formatText, FormattedText } = require('core/i18n').i18n;
const { formatCurrency, formatAmount } = require('utilities/currencyHelper');

// @ commons
const { OKMessage } = require('commonsComponents/OKMessage');
const WebappRender = require('components/conditionalRender/webappRender');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @ components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

// @ constants
const { MYPROFILE_BROKER_URL, MYPROFILE_BROKER_EXPLORE_STOCKS_URL,  } = require('constants/index');

// @utilities
const PersonalDataHelper = require('utilities/personalDataHelper');
const { catalogue, analyticsId } = require('../analytics/brockerStocksContract.tracking');
const { recordLinkV2 } = require('utilities/tagging');

class BrokerStocksContractStepSuccess extends React.Component {

    componentDidMount() {
        recordLinkV2(catalogue[analyticsId.BROKER_STOCKS_CONTRACT_STEP_3_SUCCESS]());
    }

    buildInterveners(interveners) {
        return interveners.map( (intervener, index) => {
            return (
                <OKInformativeListItem
                    key={index}
                    title={intervener.get('name')}
                    bodyText={intervener.get('type')}
                    isUppercaseTitle={false}
                    className="stocks-contract-step-success__contract-intervinient-title"
                />
            );
        });
    }

    render(){
        const { immAccount, immStocksContractForm } = this.props;

        const accountAlias = immAccount.get('accountType');
        const accountNumber = immAccount.get('iban');

        const balanceCurrency = immAccount.get('balance').get('currency');
        const balanceAmount = immAccount.get('balance').get('amount');

        const intervenersRows = immStocksContractForm.getIn(['steps', 1, 'interveners']);
        const interveners = this.buildInterveners(intervenersRows);
        const associatedAccountBalance = formatText('stocksContract-accountBalanceLong')+': '+formatAmount(balanceAmount)+' '+formatCurrency(balanceCurrency);
        const successMessage = formatText('stocksContract-successMessage');
        const secondaryButtonLabel = formatText('stocksContract-buyStocks');
        const mainButtonLabel = formatText('stocksContract-backToWallet');
        const contractNumber = immStocksContractForm.getIn(['orderConfirmation','contract','number']);
        const contractNumberLabel = `${formatText("stocksContract-contractNumber")} ${contractNumber}`;

        return (
            <div className="stocks-contract-step-success">
                <WizardSuccess
                    successMessage={successMessage}
                    successSubMessage={contractNumberLabel}
                    customClassName="stocks-contract-step-success"
                    mainButton={{label: mainButtonLabel, url: MYPROFILE_BROKER_URL}}
                    secondaryButton={{label:secondaryButtonLabel, url: MYPROFILE_BROKER_EXPLORE_STOCKS_URL}}
                    secondaryButtonStyle={__CONTACT_CENTER__ ? 'secondary' : null}
                    tealium={catalogue[analyticsId.BROKER_STOCKS_CONTRACT_SUCCESS]()}
                    isSecondVersion
                >
                    <div className="stocks-contract-step-success__contract-data">
                        <div className="stocks-contract-step-success__contract-data-title">
                            <FormattedText value="stocksContract-accountDataTitle" />
                        </div>
                        <div className="stocks-contract-step-success__contract-data-left">
                            <div className="stocks-contract-step-success__contract-data-left-title">
                                <FormattedText value="stocksContract-accountDataLeftTitle" />
                            </div>
                            <div className="stocks-contract-step-success__account-type">
                                {accountAlias}
                            </div>
                            <div className="stocks-contract-step-success__account-number">
                                {accountNumber}
                            </div>
                            <div className="stocks-contract-step-success__account-balance">
                                {associatedAccountBalance}
                            </div>
                        </div>
                        <div className="stocks-contract-step-success__contract-data-right">
                            <div className="stocks-contract-step-success__contract-data-right-title">
                                <FormattedText value="stocksContract-accountDataRightTitle" />
                            </div>
                            <OKInformativeList>
                                {interveners}
                            </OKInformativeList>
                        </div>
                    </div>
                    <WebappRender>
                        <div className="stocks-contract-step-success__email-message">
                            <OKMessage type="informative">
                                <FormattedText
                                    value="broker-stockContractEmailMessage"
                                    injectedStrings={[PersonalDataHelper.getEmail(this.props.immProfile)]}
                                />
                            </OKMessage>
                        </div>
                    </WebappRender>
                </WizardSuccess>
            </div>
        );
    }
}

BrokerStocksContractStepSuccess.propTypes = {
    immAccount: PropTypes.object,
    immStocksContractForm: PropTypes.object,
    immProfile: PropTypes.object.isRequired,
};

module.exports = BrokerStocksContractStepSuccess;
